import React, { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import {
  Select as MUISelect,
  ListSubheader,
  MenuItem,
  Input,
  Tooltip,
  makeStyles,
} from '@material-ui/core/';

import { Box, SvgIcon } from 'Components/Base';

const inputStyle = makeStyles({
  root: ({ colors }) => ({
    fontFamily: 'Noto Sans, Noto Sans Thai, sans-serif',
    fontSize: '12px',
    background: colors.coolGrey.grey3,
    width: '108px',
    height: '36px',
    color: colors.text,
    borderRadius: '40px',
    cursor: 'pointer',
    textAlign: 'center',
    '&:before': {
      display: 'none',
    },
    '& .MuiSelect-nativeInput': {
      display: 'none',
    },
    '& .MuiSelect-select:focus': {
      background: 'none',
    },
    '& .MuiSelect-select.MuiSelect-select': {
      padding: '0px',
      paddingRight: '26px',
    },
  }),
});

const subHeaderStyle = makeStyles({
  root: ({ colors }) => ({
    fontFamily: 'Noto Sans, Noto Sans Thai, sans-serif',
    fontSize: '14px',
    background: colors.white,
    color: colors.primary,
  }),
});

const menuStyle = makeStyles({
  root: {
    fontFamily: 'Noto Sans, Noto Sans Thai, sans-serif',
    fontSize: '16px',
  },
});

const useToolTipStyles = makeStyles({
  popper: {
    zIndex: 1,
  },
  tooltip: ({ colors, space }) => ({
    fontFamily: 'Noto Sans, Noto Sans Thai, sans-serif',
    background: colors.primary,
    color: colors.white,
    padding: `${space[2]}px`,
    margin: `${space[2]}px ${space[0]}px`,
    textAlign: 'center',
    borderRadius: '8px',
    height: '30px',
    width: '117px',
    fontSize: '12px',
  }),
  arrow: ({ colors }) => ({
    color: colors.primary,
  }),
});

const TuneIcon = (props) => (
  <SvgIcon
    icon={SvgIcon.ICON_LIST.TUNE}
    size={16}
    style={{ top: '10px', right: '20px', transform: 'none' }}
    {...props}
  />
);

const Select = styled((props) => <MUISelect {...props} />)`
  [role='button']:focus {
    background: none;
  }
`;

const CourseFilterWithButtonFilled = ({
  dialogMessage,
  expiredCoursesCount,
  selectedFilters,
  onFilterChange,
  filterOptions,
  ...props
}) => {
  const { colors, space } = useTheme();
  const inputClasses = inputStyle({ colors });
  const subHeaderClasses = subHeaderStyle({ colors });
  const menuClasses = menuStyle();
  const tooltipClasses = useToolTipStyles({ colors, space });
  const [showDialog, setShowDialog] = useState(true);
  const { courseFilter, sortFilter } = filterOptions;

  return (
    <Box {...props}>
      <Tooltip
        title={dialogMessage}
        open={expiredCoursesCount > 0 && showDialog}
        classes={tooltipClasses}
        placement={'top'}
        arrow
      >
        <Select
          multiple
          disableUnderline={true}
          MenuProps={{ getContentAnchorEl: null, id: 'course-filter-select' }}
          renderValue={() => 'ตัวกรอง'}
          value={selectedFilters}
          onOpen={() => setShowDialog(false)}
          onChange={(e) => {
            onFilterChange(e.target.value);
          }}
          IconComponent={TuneIcon}
          input={<Input classes={inputClasses} />}
        >
          {courseFilter.items.length > 0 && (
            <ListSubheader classes={subHeaderClasses}>{courseFilter.label}</ListSubheader>
          )}
          {courseFilter.items.map((item) => (
            <MenuItem value={item.value} classes={menuClasses} key={item.value}>
              {item.label}
            </MenuItem>
          ))}
          {sortFilter.items.length > 0 && (
            <ListSubheader classes={subHeaderClasses}>{sortFilter.label}</ListSubheader>
          )}
          {sortFilter.items.map((sort) => (
            <MenuItem autoFocus={false} value={sort.value} classes={menuClasses} key={sort.value}>
              {sort.label}
            </MenuItem>
          ))}
        </Select>
      </Tooltip>
    </Box>
  );
};

export default CourseFilterWithButtonFilled;
